export const gradeColors = {
  A: "#81DE76",
  B: "#FFA351",
  C: "#ED4A3C",
  D: "#ED4A3C",
  E: " #ED4A3C",
  F: "#ED4A3C",
};
